import Category from "../common/models/category/category.model";
import {axiosRequest} from "./apiBase";

export const getProfileCategories = async (): Promise<Category[]> => {
    return axiosRequest(
        "GET",
        "category/userControlledCategories"
    );
}
